/**
 * Löst die Sicherheitsaufgabe öffentlicher Formulare: Suche einer Zahl n, sodass
 * SHA-256("<salt>:<n>") mit `difficulty` hexadezimalen Nullen beginnt.
 * Läuft in kleinen Paketen, damit die Oberfläche flüssig bleibt.
 */
export async function solveChallenge(challenge: string, difficulty: number, signal?: AbortSignal): Promise<string> {
  const salt = challenge.split('.')[0]!;
  const enc = new TextEncoder();
  const fullBytes = Math.floor(difficulty / 2);
  const halfByte = difficulty % 2 === 1;
  for (let n = 0; ; n += 200) {
    if (signal?.aborted) throw new Error('abgebrochen');
    const batch = await Promise.all(
      Array.from({ length: 200 }, (_, i) => crypto.subtle.digest('SHA-256', enc.encode(`${salt}:${n + i}`))),
    );
    for (let i = 0; i < batch.length; i++) {
      const b = new Uint8Array(batch[i]!);
      let ok = true;
      for (let k = 0; k < fullBytes; k++) if (b[k] !== 0) ok = false;
      if (ok && halfByte && b[fullBytes]! >> 4 !== 0) ok = false;
      if (ok) return String(n + i);
    }
  }
}
